import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionInstanGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentToken = this.authService.currentTokenValue;
        if (currentToken) {
            let currentUser = this.authService.currentUserValue;
            const permissionUser = currentUser['status'];
            if (permissionUser == 1) {
                return false;
            }else{
                return true;
            }
        }

        return true;
    }
}
